import { render } from "./FundList1.vue?vue&type=template&id=88e101c4"
import script from "./FundList1.vue?vue&type=script&lang=js"
export * from "./FundList1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__